
import { supabase } from "@/integrations/supabase/client";

export async function processInvitations(userEmail: string | null, userId: string | undefined, invitationData: any[]) {
  if (!userEmail || !userId || !invitationData.length) return;
  
  for (const invitation of invitationData) {
    if (invitation.resource) {
      try {
        // Create a resource share
        const { error: shareError } = await supabase
          .from('resource_shares')
          .upsert({
            resource_id: invitation.resource.id,
            trainee_id: userId,
            status: 'accepted',
            progress: 0,
            last_viewed_page: 1
          });

        if (shareError) {
          console.error('Error creating resource share:', shareError);
        } else {
          // Update invitation status
          const { error: updateError } = await supabase
            .from('resource_invitations')
            .update({ status: 'accepted' })
            .eq('email', userEmail)
            .eq('resource_id', invitation.resource.id);

          if (updateError) {
            console.error('Error updating invitation status:', updateError);
          } else {
            console.log('Accepted invitation for resource:', invitation.resource.id);
          }
        }
      } catch (e) {
        console.error('Error processing invitation:', e);
      }
    }
  }
}
